import { axiosInstanceWithToken } from 'utils/axios';
import { IUnsubscribe } from '../../server/types';

export const unsubscribeEmail = async (data: IUnsubscribe) => axiosInstanceWithToken().post('emails/unsubscribe', data);
